module.exports = __webpack_public_path__ + "img/horizontal_6_7_7005.06790279.png";